document.addEventListener("DOMContentLoaded", function () {
  const TRANSFER_DISCOUNT = 0.80; // 20% OFF con transferencia (29/9/26: vuelve a 20% para FIEBRE)
  // 2026-09-03: cuotas sin interés por monto (config Mercado Pago):
  // 6 cuotas desde $250.000 · 3 cuotas desde $100.000 · 2 cuotas sin mínimo.
  function cuotasPara(precio) { return precio >= 250000 ? 6 : precio >= 100000 ? 3 : 2; }

  // 2026-09-03: la tienda ya muestra precios SIN centavos ($221.200).
  // Si no hay coma, los puntos son separadores de miles y se sacan.
  function parseMoneyToNumber(text) {
    if (!text) return null;
    let clean = text.replace(/\s/g, "").replace(/[^\d.,]/g, "");
    if (!clean) return null;
    if (clean.includes(",")) {
      clean = clean.replace(/\./g, "").replace(",", ".");
    } else {
      clean = clean.replace(/\./g, "");
    }
    const value = parseFloat(clean);
    return isNaN(value) ? null : value;
  }

  function formatMoney(value) {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
      .format(value)
      .replace("ARS", "")
      .trim();
  }

  function getProductCards() {
    return document.querySelectorAll(
      ".card-wrapper, .card, .product-card, .grid__item, li[class*='product'], div[class*='product-card']"
    );
  }

  // Devuelve { price, onSale }.
  // onSale es true si hay 2+ montos distintos O si existe un elemento de precio
  // comparado/tachado (compare-at). Precio final = el menor.
  function getPriceInfo(card) {
    const nums = [];
    card.querySelectorAll("[class*='price']").forEach(function (el) {
      const t = el.textContent;
      if (!t || t.indexOf("$") === -1) return;
      const m = t.match(/\$[\s]?[0-9.,]+/g);
      if (!m) return;
      m.forEach(function (x) {
        const n = parseMoneyToNumber(x);
        if (n && n > 0) nums.push(n);
      });
    });

    if (!nums.length) return null;

    const distinct = Array.from(new Set(nums));
    const min = Math.min.apply(null, distinct);
    const max = Math.max.apply(null, distinct);

    // Deteccion robusta de oferta: 2 precios distintos O elemento tachado/compare presente.
    let onSale = distinct.length > 1 && max > min;
    if (!onSale) {
      const cmp = card.querySelector(
        "[class*='compare'], s[class*='price'], del[class*='price'], .price--on-sale, .price-item--regular"
      );
      if (cmp && (cmp.textContent || "").indexOf("$") !== -1) onSale = true;
    }

    return { price: min, onSale: onSale };
  }

  function getInsertTarget(card) {
    const targets = [
      ".card__information",
      ".card-information",
      ".product-card__info",
      ".product-card-information",
      ".full-unstyled-link",
      "[class*='information']",
      "[class*='content']"
    ];
    for (const selector of targets) {
      const el = card.querySelector(selector);
      if (el) return el;
    }
    return card;
  }

  function addPaymentInfo() {
    const cards = getProductCards();

    cards.forEach(function (card) {
      if (card.querySelector('.opposite-final-sale-price')) return; // Skip Final Sale products

      const productLink = card.querySelector("a[href*='/products/']");
      if (!productLink) return;

      const info = getPriceInfo(card);
      if (!info || !info.price) return;

      const existing = card.querySelector(".custom-payment-info");

      // Autocorreccion: si ya tiene el bloque pero ahora detectamos oferta,
      // sacamos la linea de transferencia (por si el precio tachado cargo tarde).
      if (existing) return;

      const price = info.price;
      const INSTALLMENTS = cuotasPara(price);
      const installmentPrice = price / INSTALLMENTS;

      const paymentInfo = document.createElement("div");
      paymentInfo.className = "custom-payment-info";

      // En productos EN OFERTA NO se muestra la linea de transferencia
      // (el descuento de transferencia no es acumulable con el sale).
      let html = "";

      {
        const transferPrice = price * TRANSFER_DISCOUNT;
        html += `
        <p class="custom-payment-info__transfer">
          ${formatMoney(transferPrice)} con Transferencia
        </p>`;
      }

      html += `
        <p class="custom-payment-info__installments">
          ${INSTALLMENTS} cuotas sin interés de ${formatMoney(installmentPrice)}
        </p>`;

      paymentInfo.innerHTML = html;

      const target = getInsertTarget(card);
      target.appendChild(paymentInfo);
    });
  }

  addPaymentInfo();

  // Re-corridas de seguridad por si el precio (tachado) carga tarde en conexiones lentas.
  setTimeout(addPaymentInfo, 400);
  setTimeout(addPaymentInfo, 1200);
  setTimeout(addPaymentInfo, 3000);

  document.addEventListener("shopify:section:load", addPaymentInfo);

  const observer = new MutationObserver(function () {
    addPaymentInfo();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

/* 2026-09-29: vuelve a 20% por transferencia (tema FIEBRE). */
